__turbopack_context__.v({
  "container": "UGCHighlightModal-module__IM_Pzq__container",
  "header": "UGCHighlightModal-module__IM_Pzq__header",
  "imageWrapper": "UGCHighlightModal-module__IM_Pzq__imageWrapper",
});
